// -----------------------------------------------------------
// FloraIQ - LoadingSkeleton Unificado
// -----------------------------------------------------------

export interface LoadingSkeletonProps {
  type?: "card" | "table" | "chart" | "kpi-grid";
  count?: number;
}

export default function LoadingSkeleton({ type = "card", count = 4 }: LoadingSkeletonProps) {
  if (type === "kpi-grid") {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="rounded-card border border-background-200/70 p-4 animate-pulse">
            <div className="h-3 bg-background-200 rounded w-2/3 mb-3"></div>
            <div className="h-6 bg-background-200 rounded w-1/2 mb-2"></div>
            <div className="h-3 bg-background-200 rounded w-1/3"></div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "table") {
    return (
      <div className="rounded-card border border-background-200/70 overflow-hidden animate-pulse">
        <div className="h-10 bg-background-100 border-b border-background-200/70"></div>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="h-14 border-b border-background-200/70 flex items-center px-4 gap-4">
            <div className="h-3 bg-background-200 rounded w-1/4"></div>
            <div className="h-3 bg-background-200 rounded w-1/6"></div>
            <div className="h-3 bg-background-200 rounded w-1/6"></div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "chart") {
    return (
      <div className="rounded-card border border-background-200/70 p-5 animate-pulse">
        <div className="h-4 bg-background-200 rounded w-1/3 mb-4"></div>
        <div className="h-48 bg-background-100 rounded"></div>
      </div>
    );
  }

  // default: card grid
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-card border border-background-200/70 p-5 animate-pulse">
          <div className="h-4 bg-background-200 rounded w-2/3 mb-3"></div>
          <div className="h-3 bg-background-200 rounded w-full mb-2"></div>
          <div className="h-3 bg-background-200 rounded w-5/6"></div>
        </div>
      ))}
    </div>
  );
}